import styles from './ProductQuiz.module.scss';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { ProductQuizProvider, useProductQuiz } from './ProductQuizContext';
import { ProductQuizBanner } from './ProductQuizBanner';
import { Container, Flex, Transition } from '@mantine/core';
import { isMobileDevice } from '../../lib/util/isMobileDevice';
import { useTransition, TRANSITION_DURATION } from './Helpers/useTransition';
import * as types from '../../types';
import { useLocale, collarProductIsSupportedInCountry } from '../../contexts/LocaleContext';
import AppPaths from '../../AppPaths';

const Quiz: React.FC = () => {
  const { component, recommendation, currentQuestionIndex } = useProductQuiz();
  const isMobile = isMobileDevice();
  const { visible, displayedNode } = useTransition(component, currentQuestionIndex);

  const { country } = useLocale();
  if (!collarProductIsSupportedInCountry(types.miniCollarId, country)) {
    return <Redirect to={AppPaths.Products(types.series3PlusCollarId)} />;
  }

  if (recommendation) {
    return (
      <Container fluid px={0} className={`${styles.quizContainer} quiz-container-global`}>
        <ProductQuizBanner finished={true} />
        <Flex
          direction="column"
          justify="center"
          gap={isMobile ? 16 : 24}
          align="stretch"
          mt={27}
          mb={24}
          sx={{
            marginLeft: '5%',
            marginRight: '5%',
            '@media (min-width: 1000px)': {
              marginLeft: '30%',
              marginRight: '30%',
            },
          }}
        >
          {recommendation}
        </Flex>
      </Container>
    );
  }

  return (
    <Container fluid px={0} className={`${styles.quizContainer} quiz-container-global`}>
      <ProductQuizBanner finished={false} />
      <Transition mounted={visible} transition="fade" duration={TRANSITION_DURATION} timingFunction="ease">
        {(transitionStyles) => (
          <Flex
            direction="column"
            justify="center"
            gap={isMobile ? 24 : 40}
            align="stretch"
            mt={isMobile ? 40 : 120}
            mb={24}
            sx={{
              marginLeft: '5%',
              marginRight: '5%',
              '@media (min-width: 1000px)': {
                marginLeft: '30%',
                marginRight: '30%',
              },
            }}
            style={transitionStyles}
          >
            {displayedNode}
          </Flex>
        )}
      </Transition>
    </Container>
  );
};

export const ProductQuiz: React.FC = () => {
  return (
    <ProductQuizProvider>
      <Quiz />
    </ProductQuizProvider>
  );
};
